import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from './en'
import zhLocale from './zh'
import enUsLocale from 'element-ui/lib/locale/lang/en';
import zhCnLocale from 'element-ui/lib/locale/lang/zh-CN';

import { Base64 } from "js-base64";
// import localStore from '~script/localStore';

Vue.use(VueI18n)

console.log('navigator ===>', navigator.language)
// localStorage.removeItem('language')
const navLang = navigator.language;
const localLang = (navLang == 'zh-CN' || navLang == 'en') ? navLang : false;

let jumpObj = null

if(window.location.href.split('?').length>1){
    const hrefUrl = window.location.href
    let urlArr = hrefUrl.split('?')[0].split('/')
    let urlLen = urlArr.length
    let url = urlArr[urlLen-1]
    let param = Base64.decode(window.location.href.split('?')[1])
    param = param.replace('C2A0', ' ');
    param = param.replace('?', '');
    let arr = param.split('&')
    let obj = {}
    arr.forEach(v=>{
        Vue.prototype.$set(obj, v.split('=')[0], v.split('=')[1])
    })
    console.log(obj)
    jumpObj = obj
    let language = (obj.lang && (obj.lang=='en-US'||obj.lang=='en_US')) ? 'en-US' : 'zh-CN'
    localStorage.setItem('language', language)
}
if(jumpObj){
    localStorage.setItem("jumpObj", JSON.stringify(jumpObj))
}

let lang = localStorage.getItem('language') || localLang || 'zh-CN'; //zh-CN 默认中文

Vue.config.lang = lang;
console.log('VueI18n ===>', lang)
// 多语言配置 vue-i18n 6.x+
Vue.locale = () => { };
const messages = {
    'zh-CN': Object.assign(zhLocale,zhCnLocale),
    'en-US': Object.assign(enLocale,enUsLocale)
};
const i18n = new VueI18n({
    locale: lang,
    messages,
    silentTranslationWarn: true
});

export default i18n;



// WEBPACK FOOTER //
// ./src/components/lang/index.js